import { ColDef, ValueGetterParams } from 'ag-grid-community';
import { SyncPlan } from './SyncPlan';
import { AttributeSyncPlanApiModel } from '../../../../types/models/sync/attribute-sync-plan.model';

type Props = { plan: AttributeSyncPlanApiModel; onPlanChanged?: (newPlan: AttributeSyncPlanApiModel) => void };
type RowType =
  | AttributeSyncPlanApiModel['create'][number]
  | AttributeSyncPlanApiModel['update'][number]
  | AttributeSyncPlanApiModel['delete'][number];

export const AttributeSyncPlan = ({ plan, onPlanChanged }: Props) => {
  const columns: ColDef<RowType>[] = [
    { field: 'name', filter: true },
    { field: 'node.name', headerName: 'Survey Code', filter: true },
    { field: 'node.parent', headerName: 'Category', filter: true },
    { field: 'description', filter: true },
    { field: 'type', filter: true },
    { field: 'entryType', filter: true },
    { field: 'minimumValue', headerName: 'Minimum', filter: true },
    { field: 'maximumValue', headerName: 'Maximum', filter: true },
    { field: 'numberOfDecimals', filter: true },
    { field: 'values', filter: true },
    { field: 'defaultValue', filter: true },
    {
      field: 'domains',
      filter: true,
      valueGetter: ({
        data,
      }: ValueGetterParams<
        AttributeSyncPlanApiModel['create'][number] | AttributeSyncPlanApiModel['update'][number]
      >) => data?.domains?.map(({ name }) => name).join(', '),
    },
  ];

  return <SyncPlan plan={plan} columns={columns} onPlanChanged={onPlanChanged} />;
};
